import { render, staticRenderFns } from "./FinanceRatioTable.vue?vue&type=template&id=c07dc944&scoped=true&"
import script from "./FinanceRatioTable.vue?vue&type=script&lang=js&"
export * from "./FinanceRatioTable.vue?vue&type=script&lang=js&"
import style0 from "./FinanceRatioTable.vue?vue&type=style&index=0&id=c07dc944&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07dc944",
  null
  
)

export default component.exports